<script>
import Config from './config.vue';
import EditDelta from './edit-delta.vue';
import planPropsMixin from '@/plans/mx/plan-props';

export default {
  mixins: [planPropsMixin],
  render() {
    if (this.$context.is.edit) {
      if (this.$context.is.addQty) {
        return <EditDelta on={this.$listeners} />;
      } else {
        return <Config on={this.$listeners} />;
      }
    } else {
      return <Config on={this.$listeners} />;
    }
  },
};
</script>
